<template>
  <el-container style="height: 100vh; border: 1px solid #eee">
    <!-- <el-header style="display:flex; font-size: 12px;justify-content:space-between;align-items:center;"> -->
    <el-header>
      <el-col :span="6" style="display:flex;justify-content:space-between;align-items:center;height:100%;">
        <img src="../assets/logo.png" style="width:40px;height:40px;"/>
        <span style="flex:6;display:flex;flex-direction:column;align-items:baseline;color:#fff;margin-left:15px;">
          <span style="flex:1">润泽园区商户系统</span>
          <span style="flex:1;font-size:12px;">Range Park</span>
        </span>
      </el-col>
      <el-col :span="6" :offset="12" style="height:100%;display:flex;justify-content:flex-end;align-items:center;">
        <el-col style='cursor:pointer;display:flex;justify-content:flex-end;align-items:center;'>
          <!-- 管理人员按钮，后加的，只有是润泽食堂的时候 才显示 -->
          <div class="manage-mems" v-if="mchId == '2985139383174144'" @click="goToManage"><u>管理人员</u></div>
          <el-popover
            placement="left"
            title="提示"
            width="200"
            trigger="hover"
            content="点击可下载用于打印的二维码">
            <a slot="reference" target="_blank" @click="downQrcode">
            <!-- <a slot="reference" :href="'http://test.cms.rangepark.cn/sps/mp/QrcodeDown/'+mchId"> -->
              <img style="width:30px;height:30px;margin-right:30px;" src="../assets/images/ercode_icon.png">
            </a>
           
          </el-popover>
          
          <img :src="chooseCompany.logo" style="width:40px;height:40px;border-radius:50%;overflow:hidden;margin-right:10px;"/>
          <el-dropdown style="">
            <span class="el-dropdown-link" style="color:#fff">
              {{chooseCompany.name}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item 
                v-for="(item,index) in companyList" 
                :key="index" 
                @click.native="selectStore(index)"
              >
                {{item.name}}
              </el-dropdown-item>
              <el-dropdown-item divided @click.native="logOut" style="color:red">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-col>
    </el-header>
    <el-container>
      <el-aside width="180px" style="background-color: rgb(28,36,43)">
        <el-menu 
          @select="handleSelect" 
          :default-active="editableTabsValue"
          style="background-color: rgb(28,36,43);"
        >
          <el-menu-item 
            v-for="(item,index) in menus" 
            :index="item.path" 
            :key="index"              
            @click.native="addTab(item.name,item.path)"
            v-show='item.show&&index<= 3'
          >
            <i :class="item.icon"></i>
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
          <el-submenu class='submenu' index="/main/storeUp" style="background-color: rgb(28,36,43);">
            <template slot="title">
              <i class="goods icon iconfont icon-all"></i>
              商品管理
            </template>
            <el-menu-item index="/main/storeUp" @click.native="addTab('商品上架','/main/storeUp')">商品上架</el-menu-item>
            <el-menu-item index="/main/storeDown" @click.native="addTab('商品下架','/main/storeDown')">商品下架</el-menu-item>
            <el-menu-item index="/main/preSellList" @click.native="addTab('预售商品','/main/preSellList')">预售商品</el-menu-item>
          </el-submenu>
          <el-submenu class='submenu' index="/main/seckill" style="background-color: rgb(28,36,43);">
            <template slot="title">
              <i class="goods icon iconfont el-icon-present"></i>
              活动管理
            </template>
            <el-menu-item index="/main/seckill" @click.native="addTab('秒杀','/main/seckill')">秒杀</el-menu-item>
            <el-menu-item index="/main/videoShop" @click.native="addTab('视频购','/main/videoShop')">视频购</el-menu-item>
            <el-menu-item index="/main/redPacket" @click.native="addTab('实物红包','/main/redPacket')">实物红包</el-menu-item>
          </el-submenu>
          <el-submenu class='submenu' index="/main/shopManage" style="background-color: rgb(28,36,43);">
            <template slot="title">
              <i class="goods icon iconfont el-icon-s-tools"></i>
              商铺管理
            </template>

            <el-menu-item index="/main/shopManage" @click.native="addTab('店铺装修','/main/shopManage')">商城店铺装修</el-menu-item>
            <!-- <el-menu-item index="/main/staffManagement" @click.native="addTab('员工管理','/main/staffManagement')">员工管理</el-menu-item>
            <el-menu-item index="/main/roleManagement" @click.native="addTab('角色管理','/main/roleManagement')">角色管理</el-menu-item> -->
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <el-tabs 
          v-model="editableTabsValue" 
          type="border-card" 
          closable 
          @tab-remove="removeTab"
          @tab-click="handleClick"
        >
          <el-tab-pane v-for="item in editableTabs" :key="item.name" :label="item.title" :name="item.name">
            <router-view/>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { logout } from '@/api/login';
import bus from '@/utils/BusEvent';
import { mapGetters, mapActions } from 'vuex';
import {shop_url} from '@/global';
import { qrcodeDown } from '@/utils/downloadFetch';

export default {
  data () {
    return {
      menus: [
        {
          name: '首页',
          path: '/main',
          icon: 'el-icon-admin-shangdian1',
          show: true
        },
        {
          name: '交易管理',
          path: '/main/trademanage',
          icon: 'el-icon-admin-jinqian-shixin',
          show: true
        },
        {
          name: '资产管理',
          path: '/main/indexshow',
          icon: 'el-icon-admin-zichanguanli',
          show: true
        },
        {
          name: '客户用餐',
          path: '/main/dinner',
          icon: 'el-icon-admin-fapiao',
          show: true
        },
        {
          name: '商品管理',
          path: '/main/storeUp',
          icon: 'el-icon-admin-zichanguanli',
          show: true,
          children: [
            {
              name: '商品上架',
              path: '/main/storeUp',
              icon: 'el-icon-admin-zichanguanli',
              show: true
            },
            {
              name: '商品下架',
              path: '/main/storeDown',
              icon: 'el-icon-admin-zichanguanli',
              show: true
            },
            {
              name: '预售商品',
              path: '/main/storeDown',
              icon: 'el-icon-admin-zichanguanli',
              show: true
            }
          ]
        },
        {
          name: '活动管理',
          path: '/main/seckill',
          icon: 'el-icon-admin-zichanguanli',
          show: true,
          children: [
            {
              name: '秒杀',
              path: '/main/seckill',
              icon: 'el-icon-admin-zichanguanli',
              show: true
            },
            {
              name: '视频购',
              path: '/main/videoShop',
              show: true
            }
          ]
        },
        {
          name: '店铺管理',
          path: '/main/shopManage',
          // icon: 'el-icon-admin-zichanguanli',
          show: true,
          children: [
            {
              name: '店铺装修',
              path: '/main/shopManage',
              // icon: 'el-icon-admin-zichanguanli',
              show: true
            },
            {
              name: '员工管理',
              path: '/main/staffManagement',
              show: true 
            }
          ]
        },
      ],
      editableTabsValue: '/main',
      editableTabs: [],
      tabPaths: [],
      id: '',
      downUrl: shop_url
    }
  },
  created () {
    this.getHomepage()
  },
  mounted () {
    this.setTab()
    bus.$on('toLogin', () => {
      // this.$router.push('/login')
    })
    this.test()
  },
  distroyed () {
    bus.$off('toLogin')
  },
  watch: {
    chooseCompany () {
      // console.log(123)
      this.test()
    }
  },
  computed: {
    ...mapGetters(['chooseCompany', 'companyList', 'mchId'])
  },
  methods: {
    test () {
      // console.log(this.chooseCompany)
      this.menus.forEach(item => {
        if (item.name == '客户用餐') {
          this.chooseCompany.id !== 2985139383174145 ? item.show = false:item.show = true
        }
      })
      // console.log(this.menus)
      return this.menus
    },
    ...mapActions(['getHomepage']),
    setTab () {
      let activeRouterPath = this.$route.path
      if (this.editableTabs.length === 0) {
        if (activeRouterPath) {
          this.addTab(this.$route.name, this.$route.path)
          this.$router.push(activeRouterPath)
          this.handleSelect(activeRouterPath)
        } else {
          this.addTab('首页', '/main')
          this.$router.push('/main')
          this.handleSelect('/main')
        }
      }
    },
    downQrcode () {
      qrcodeDown({
        method: 'get',
        url: `${shop_url}/shop/mp/QrcodeDown/`+(this.$store.getters.chooseCompany).id,
        fileName: `${(this.$store.getters.chooseCompany).name}.png`
      }).then(res => {})
    },
    logOut () {
      const _this = this
      logout()
        .then(res => {
          _this.$router.replace({ path: '/login' })
          _this.$store.commit('SET_INFO', { isLogin: false , deep: true})
        })
        .catch(err => {})
    },
    selectStore (index) {
      let data = {
        companyIndex: index
      }
      this.$store.commit('SET_INFO', data)
      this.getHomepage()
      let tradeData = {
        // id: 0,
        mchId: this.$store.getters.mchId,
        page: 1,
        type: 0
      }
      let assetData = {
        mchId: this.$store.getters.mchId,
        page: 1,
        status: -1,
        rows: 10
      }
      this.$store.dispatch('getTradeInfo', tradeData)
      this.$store.dispatch('getAssetInfo', tradeData)
      const path = '/main'
      if (this.tabPaths.includes(path)) {
        this.handleClick({name: path})
      } else {
        this.tabPaths.push(path)
        this.editableTabs.push({
          title: '首页',
          name: path
        })
        this.editableTabsValue = path
        this.$router.push('/main')
        this.handleSelect('/main')
      }
    },

    handleSelect (index, indexPath, indexTitle) {
      this.$router.push(index)
    },
    handleClick (tab, event) {
      this.editableTabsValue = tab.name
      this.$router.push(tab.name)
    },
    addTab (targetName, path, judege) {
      let newTabObj = {
        title: targetName,
        name: path
      }
      if (this.tabPaths.includes(path)) {
        this.editableTabsValue = path
      } else {
        this.tabPaths.push(path)
        this.editableTabs.push(newTabObj)
        this.editableTabsValue = path
      }
    },
    removeTab (targetName) {
      let tabs = this.editableTabs
      let tns = this.tabPaths
      let activeName = this.editableTabsValue

      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }
      this.tabPaths = tns.filter(tn => tn !== targetName)
      this.editableTabsValue = activeName
      this.editableTabs = tabs.filter(tab => tab.name !== targetName)
      this.$router.push(this.editableTabsValue)
    },
    /*
      显示润泽员工管理页面
     */
    goToManage () {
      this.addTab('管理人员', '/main/managemems')
      localStorage.mchId = this.mchId//目前只有员工管理会用到
      this.handleSelect('/main/managemems')
    }
  }
}
</script>
<style lang="scss">
  .el-menu {
    border: none;
    background-color: transparent !important;
  }
  .el-submenu__title i {
    color: #fff;
  }
  .submenu .el-submenu__title{
    color: #fff;
  }
  .submenu .el-submenu__title:focus,.submenu .el-submenu__title:hover{
    background-color: rgb(28, 36, 43) !important;
    color: #2ecc72 !important;
  }
  .submenu .goods {
      vertical-align: middle;
      margin-right: 5px;
      width: 24px;
      text-align: center;
      font-size: 24px;
  }
  .submenu:hover .el-submenu__title, .submenu:focus  .el-submenu__title{
    color: #2ecc72 !important;
  };
  .submenu:hover .el-submenu__title i,.submenu:focus .el-submenu__title i{
    color: #2ecc72 !important;
  }
</style>
<style scoped>
/* @import "../assets/icon/iconfont.css"; */
.el-header {
  background-color: #3dd278;
  color: #333;
}

.el-main {
  padding: 0;
  flex: 1;
  padding-bottom: 16px;
  background-color: #e4e9ec;
  /* overflow-y: scroll; */
  /* min-height: 100%; */
  /* overflow: scroll; */
}

.el-aside {
  color: #333;
  padding-top: 20px;
}

.breadTitle {
  /* background-color: #fff; */
  margin: 0;
}


.el-submenu__title{
  color:#fff;
}
.el-menu-item {
  color: #fff;
  background-color: transparent;
}
.submenu:hover {
  background-color: transparent !important;
}
.submenu .el-submenu__title:focus,.submenu .el-submenu__title:hover{
  background-color: rgb(28, 36, 43) !important;
  color: #2ecc72 !important;
}
.el-submenu__title:focus, .el-submenu__title:hover{
  background-color: rgb(28, 36, 43);
  color: #2ecc72;
}
.el-menu-item i {
  color: #fff;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: rgb(28, 36, 43);
  color: #2ecc72;
}

.el-menu-item:focus i,
.el-menu-item:hover i {
  color: #2ecc72;
}

.el-menu-item.is-active {
  background-color: rgb(28, 36, 43);
  color: #2ecc72;
}

.el-menu-item.is-active i {
  color: #2ecc72;
}

.el-menu-item [class^="el-icon-"] {
  /* margin-right: 15px; */
  font-size: 24px;
}

.Breadcrumb {
  padding-left: 10px;
  margin-bottom: 10px;
  height: 60px;
  background-color: #eee;
}

.is-top {
  margin: 0;
}

.pane {
  /*background-color: #e4e9ec !important;*/
  /*margin: 0;*/
}
.manage-mems{
  margin-right: 20px;
  color: #fff;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/pages/Main.vue